import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Zap, CheckCircle2, X, Rocket } from 'lucide-react';

export default function UpgradePopup({ onClose, reason = "features" }) {
  const isAppLimit = reason === "applications";

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center" data-testid="upgrade-popup">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-3xl border border-[#E5E0D8] shadow-[0_20px_60px_rgb(0,0,0,0.2)] max-w-md w-full mx-6 p-8 animate-fade-up">
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#F4F1E8] flex items-center justify-center hover:bg-[#E5E0D8] transition-colors" data-testid="upgrade-popup-close">
          <X size={14} className="text-[#1C2A24]/50" strokeWidth={1.5} />
        </button>

        <div className="w-14 h-14 rounded-2xl bg-[#047857]/10 flex items-center justify-center mb-5">
          <Rocket size={24} className="text-[#047857]" strokeWidth={1.5} />
        </div>

        <h2 className="text-xl font-medium mb-2" style={{fontFamily:'Outfit'}} data-testid="upgrade-heading">
          {isAppLimit ? "You've used your 10 free applications this month" : "Apply faster with Plus"}
        </h2>
        <p className="text-sm text-[#1C2A24]/60 leading-relaxed mb-6" data-testid="upgrade-description">
          {isAppLimit
            ? "Free accounts include 10 applications per month. Upgrade to apply to unlimited jobs and use Quick Apply."
            : "You can always browse and search jobs for free. Plus members get tools to apply faster and stand out."}
        </p>

        <div className="bg-[#F4F1E8]/50 rounded-2xl p-4 mb-6">
          <p className="text-sm font-medium mb-3" style={{fontFamily:'Outfit'}}>Plus Plan — $4.99/mo</p>
          <div className="space-y-2">
            {[
              "Unlimited applications",
              "Quick Apply — apply in one click",
              "Save & track your favorite jobs",
              "Priority job alerts",
              "Full community access & chat",
              "Resume storage & tracking",
            ].map((f, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-[#1C2A24]/70">
                <CheckCircle2 size={14} className="text-[#047857] shrink-0" strokeWidth={1.5} />
                {f}
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <Link to="/membership" onClick={onClose}>
            <Button className="w-full rounded-full bg-[#047857] hover:bg-[#065F46] text-white h-12 text-sm" data-testid="upgrade-popup-cta">
              <Zap size={14} className="mr-2" strokeWidth={1.5} /> Upgrade to Plus — $4.99/mo
            </Button>
          </Link>
          <button onClick={onClose} className="w-full text-sm text-[#1C2A24]/40 hover:text-[#1C2A24]/60 transition-colors py-2" data-testid="upgrade-popup-dismiss">
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
